import React from 'react';
import { Badge, Label } from '@nooz-optics/nooz-components-lib';

export interface BlogCategoryProps {
  label: ILabel;
}

export const BlogCategoryHeader = ({ label, categories }) => (
  <div className='w-full lg:px-10 '>
    <div className='w-full flex justify-between pt-6 border-t-2'>
      <div className='flex items-center'>
        <Label
          {...label}
          color={{ classname: 'gray-800' }}
          size='5xl'
        />
      </div>
      <div className='flex flex-col justify-center items-center lg:flex-row'>
        {categories?.items.map((category, index) => (
          <div className={`${index !== 0 ? 'ml-2 pt-2 lg:pt-0' : ''}`}>
            <Badge
              size='base'
              type='white'
              dotColor={category?.color}
              label={category.label}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);
